// import React, { useEffect, useState } from "react";
// import CheckoutForm from "./CheckoutForm";
// import useCart from "../../hooks/useCart";
// import { initialPlan } from "../../constants/plans";
// import { useNavigate } from "react-router-dom";
// import { loadStripe } from "@stripe/stripe-js";
// import { Elements } from "@stripe/react-stripe-js";
// import "./index.css";

// const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

// const fetchClientSecret = (payload) => {
//   return fetch(process.env.REACT_APP_STRIPE_URL, {
//     method: "POST",
//     headers: { "Content-Type": "application/json" },
//     body: JSON.stringify(payload),
//   })
//     .then((response) => response.json())
//     .then((json) => json.clientSecret);
// };

// export default function Payment() {
//   const [orderId, setOrderId] = useState(null);

//   const { selectedPlan, addToCart } = useCart();

//   const totalAmount = selectedPlan && selectedPlan.price;

//   const navigate = useNavigate();

//   const [loading, setLoading] = useState(false);
//   const [clientSecret, setClientSecret] = useState(null);

//   useEffect(() => {
//     const generateOrderId = async () => {
//       try {
//         const timestamp = Date.now();

//         const randomPart = Math.floor(Math.random() * 1000000);

//         const uniqueId = `${timestamp}${randomPart}`;

//         setOrderId(uniqueId);

//         return uniqueId;
//       } catch (error) {
//         console.error("Error generating order ID:", error);
//       }
//     };

//     const checkout = async () => {
//       setLoading(true);

//       const orderId = await generateOrderId();

//       const payload = {
//         amount: Math.round(Number(totalAmount) * 100),
//         currency: "usd",
//         orderId: String(orderId),
//       };

//       // console.log(payload);

//       try {
//         const clientSecret = await fetchClientSecret(payload);

//         if (!clientSecret) throw new Error("Missing client secret");

//         setClientSecret(clientSecret);
//       } catch (err) {
//         console.error("Checkout error:", err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     if (selectedPlan) {
//       checkout();
//     }
//   }, [selectedPlan, totalAmount]);

//   useEffect(() => {
//     if (!selectedPlan) {
//       addToCart(initialPlan);
//     }
//   }, [selectedPlan, addToCart]);

//   return (
//     <Elements stripe={stripePromise}>
//       {loading ? (
//         <div className="flex justify-center items-center min-h-screen">
//           <div className="w-8 h-8 border-4 border-emerald-500 border-t-transparent rounded-full animate-spin"></div>
//         </div>
//       ) : [clientSecret, orderId, selectedPlan, totalAmount].every(Boolean) ? (
//         <CheckoutForm
//           {...{ clientSecret, orderId, orderItem: selectedPlan, totalAmount }}
//         />
//       ) : (
//         <p>Preparing checkout... Please wait.</p>
//       )}
//     </Elements>
//   );
// }
import React, { useEffect } from "react";
import CheckoutForm from "./CheckoutForm";
import useCart from "../../hooks/useCart";
import { initialPlan } from "../../constants/plans";
import "./index.css";

export default function Payment() {
  const { selectedPlan, addToCart } = useCart();

  // If no plan is selected, default to initial plan
  useEffect(() => {
    if (!selectedPlan) {
      addToCart(initialPlan);
    }
  }, [selectedPlan, addToCart]);

  return <CheckoutForm planName={selectedPlan?.name} />;
}
